export default {
    agreements: {
        list: [],
        edit: { agreement: {} },
        modal: { productTypes: [] },
        deleteAgreementPhotographers: []
    }
};
